import { differenceInSeconds, format } from 'date-fns';
import esLocale from 'date-fns/locale/es';
import localStorageConstants, { getFromLocalStorage } from './constants/localstorage';

export const PERSONS_MODAL_TYPES = {
  Infractor: 'Infractor',
  Testigo: 'Testigo',
  Afectado: 'Afectado',
};

const today: Date = new Date();
const tzOffset: number = today.getTimezoneOffset() * 60000; // definido explícitamente como número
export const todayInMexico: Date = new Date(today.getTime() - tzOffset - 6 * 3600000); // definido explícitamente como Fecha
export const todayISOString: string = todayInMexico.toISOString().split('T')[0]; // definido explícitamente como cadena

export const namesRegExp = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/; // definido explícitamente como RegExp

const utils = {
  parseJwt: (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  },
  getRoles() {
    const token = getFromLocalStorage(localStorageConstants.token);
    const roles = this.parseJwt(token).authorities.map((a: { authority: string }) => a.authority);
    return roles;
  },
  containsRole(role: string) {
    /** temporal */
    // const roles = [
    //   ROLES.GERENTE_COMPRAS,
    // ];

    const roles = this.getRoles();
    if (!roles) return false;

    return roles.some((e: string) => e === role);
  },
  getTimeDifferenceInSeconds: (date1: number, date2: number) => {
    return differenceInSeconds(date1, date2);
  },
  getDateFormat: (date: number, formatString = '') => {
    if (!date) return '-';
    return format(date, formatString, { locale: esLocale });
  },
  getPathFile: (pathFile: string) => `${process.env.REACT_APP_sharingUrl}/images/${pathFile}`,
  pathFile: (fileName: string, folder: string) => {
    return `${process.env.REACT_APP_sharingSite}?folder=${process.env.REACT_APP_sharingPath}/${folder}&image=${fileName}`;
  },
  getPathFileDownloadData: (pathFile: string) => {
    return `${process.env.REACT_APP_sharingUrl}/files/data${pathFile}`;
  },
  pathFileDownloadData: (fileName: string, folder: string) => {
    const credentials = window.atob(process.env.REACT_APP_sharingToken || '');
    const user = credentials?.split(':')?.[0] || '';
    const password = credentials?.split(':')?.[1] || '';
    return `?path=${process.env.REACT_APP_sharingPath}/${folder}&file=${fileName}&site=${process.env.REACT_APP_sharingSite}&user=${user}&pwd=${password}`;
  },
  createQueryParams: (baseUrl: string, obj: { [key: string]: string }) => {
    if (!obj || !Object.keys(obj).length) return baseUrl;
    const queryString = Object.keys(obj)
      .map(key => `${key}=${obj[key]}`)
      .join('&');
    return `${baseUrl}?${queryString}`;
  },
};

export default utils;
